<template>
  <div class="app-footer">
    <span class="app-footer__text">© 2025 Ключ к диагнозу. Все права защищены.</span>
    <router-link to="/pdf/policy.pdf" target="_blank" class="app-footer__link">
      Политика конфиденциальности
    </router-link>
  </div>
</template>

<script lang="ts" src="./AppFooter.ts">
</script>

<style lang="scss" scoped src="./AppFooter.scss"></style>
